<template>
  <el-dialog title="Crop Photo" :visible.sync="dialogVisible" width="600px" append-to-body @close="handleClose">
    <div style="height: 400px;">
      <vueCropper 
        ref="cropper" 
        :img="img" 
        outputType="png" 
        :info="true" 
        :full="false" 
        :canMove="true"
        :canMoveBox="true" 
        :original="false" 
        :autoCrop="true" 
        :autoCropWidth="autoCropWidth"
        :autoCropHeight="autoCropHeight"
        :fixedBox="true"
        :enlarge="4">
      </vueCropper>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleConfirm">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper';

export default {
  name: 'ImageCropperDialog',
  components: {
    VueCropper,
  },
  props: {
    // v-model 绑定（控制对话框显示/隐藏）
    value: {
      type: Boolean,
      default: false,
    },
    // 待裁剪的图片 URL 或 base64
    img: {
      type: String,
      required: true,
    },
    // 自动裁剪宽度，固定 250
    autoCropWidth: {
      type: Number,
      default: 250,
    },
    // 自动裁剪高度，固定 350
    autoCropHeight: {
      type: Number,
      default: 350,
    },
  },
  data() {
    return {
      dialogVisible: this.value,
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
      console.log('Cropper dialog visible changed:', val);
    },
    dialogVisible(val) {
      this.$emit('input', val);
    },
    img: {
      handler(newVal) {
        console.log('Cropper image changed:', newVal);
      },
      immediate: true,
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.cropper.getCropData((data) => {
        this.$emit('crop-done', data);
        this.dialogVisible = false;
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      this.$emit('crop-cancel');
    },
    handleClose() {
      this.$emit('crop-cancel');
    },
  },
};
</script>

<style scoped>
/* 可以在这里添加自定义样式 */
</style>